import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ISubSection } from './sub-section.interface';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'mlp-ng-sub-section',
    templateUrl: './sub-section.component.html',
    styleUrls: ['./sub-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SubHeaderSharedComponent implements OnInit {
    @Input() section: ISubSection;
    @Output() dropdownStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
    nav$ = new BehaviorSubject(undefined);
    showDropdown = false;

    ngOnInit(): void {
        this.nav$.next(this.section.nav);
    }

    toggleDropdown(status): void {
        this.showDropdown = status;
        this.dropdownStatus.emit(status);
    }

    closeAll(): void {
        this.toggleDropdown(false);
        this.section.nav.showMenu = false;

        this.nav$.next({ ...this.section.nav });
    }
}
